import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { GraffitiPage, GraffitiPageProps } from "./GraffitiPage";

export const EMPTY_PAGE_CONTENT: GraffitiPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/graffiti";

export const GraffitiPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<GraffitiPageProps>("graffiti_page", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <GraffitiPage {...routeProps} {...content} />;
};
